import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import * as dotenv from 'dotenv';
import {configureStore} from '@reduxjs/toolkit';
import {rootReducer} from './store';
import {Provider} from 'react-redux';
import {Router} from "react-router-dom";
import 'semantic-ui-css/semantic.min.css';
import './assets/main.css';
import {createBrowserHistory} from "history";
import App from "./App";
import ToastComponent from "./components/ToastComponent";

const history = createBrowserHistory();
const store = configureStore({
    reducer: rootReducer
});
export type AppDispatch = typeof store.dispatch;
dotenv.config();

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <App/>
            <ToastComponent/>
        </Router>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// reportWebVitals();
